import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M23 1H9a2 2 0 00-2 2v26a2 2 0 002 2h14a2 2 0 002-2V3a2 2 0 00-2-2zm0 28H9v-4h14zm0-6H9V9h14zm0-16H9V3h14z"/><circle cx="16" cy="27" r="1"/><path d="M15 6h2a1 1 0 000-2h-2a1 1 0 000 2z"/><circle cx="12" cy="5" r="1"/>';
export var SmartphoneOutlineSVG = function SmartphoneOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
SmartphoneOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(SmartphoneOutlineSVG);